module.exports = __webpack_public_path__ + "static/img/so3_2.ea0b324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_2.jpg
// module id = I7bC
// module chunks = 11